import * as activityLogger from "../helpers/activity-logger";
import mediumZoom from 'medium-zoom';

$(function () {
    if ($(".pdp-container").length === 1) {
        let $productSlider = $(".product-slider").slick({
            lazyLoad: "progressive",
            dots: false,
            infinite: true,
            speed: 300,
            autoplay: false,
            slidesToShow: 1,
            arrows: true,
        });

        $(".product-slider").click(function () {
            $productSlider.slick("slickNext");
        });

        $(window).resize(function () {
            $(".product-slider .image_wrapper").each(function () {
                var height = $(this).width();
                $(this).height(height);
            });
        });

        $(".product-slider .image_wrapper").each(function () {
            var height = $(this).width();
            $(this).height(height);
        });

        $('input[name="dutySelector_mobile"], input[name="dutySelector_desktop"]').change(function () {
            const getCurrentUrl = new URL(window.location.href);

            if ($(this).val() === "in-bond") {
                $("section.stock_type_text .delivery").addClass("d-none");
                $("section.stock_type_text .inbond").removeClass("d-none");
                $(
                    "section.pdp-stock-items .product_wrapper.in-bond"
                ).removeClass("d-none");
                $("section.pdp-stock-items .product_wrapper.delivery").addClass(
                    "d-none"
                );

                getCurrentUrl.searchParams.delete("duty");
                history.pushState(null, null, getCurrentUrl.toString());
            } else {
                $("section.stock_type_text .delivery").removeClass("d-none");
                $("section.stock_type_text .inbond").addClass("d-none");
                $(
                    "section.pdp-stock-items .product_wrapper.delivery"
                ).removeClass("d-none");
                $("section.pdp-stock-items .product_wrapper.in-bond").addClass(
                    "d-none"
                );

                getCurrentUrl.searchParams.set("duty", "delivery");
                history.pushState(null, null, getCurrentUrl.toString());
            }

            activityLogger.logActivity(
                "Dutytoggle: change",
                $("body").data("route"),
                { changeTo: $(this).val() }
            );
        });
    }

    mediumZoom('[data-zoomable]', {
        background:  'rgba(30,30,30,0.9)',
        scrollOffset: 0,
    });
});
